module.exports = __webpack_public_path__ + "img/mp4Icon.30137fc7.png";